export const PAGES = {
  HOME: "HOME",
  ATHLETE_SIGNUP: "ATHLETE_SIGNUP",
  COACH_SIGNUP: "COACH_SIGNUP",
  LOGIN: "LOGIN",
  ATHLETE_DASHBOARD: "ATHLETE_DASHBOARD",
  COACH_DASHBOARD: "COACH_DASHBOARD",
};
